export interface GithubProjectConfig {
  id: string;
  projectId: string;
  repoUrl: string;
  /**
   * Ob hinter der Bindung ein benutzbares GitHub-Token steht. Eine Bindung ohne
   * Eigentuemer (etwa aus der Migration NEX-1318) sieht sonst eingerichtet aus,
   * bleibt fuer den Beobachter aber stumm.
   */
  tokenAvailable: boolean;
}

export interface SaveGithubRepoUrlRequest {
  repoUrl: string;
}

/**
 * Die Codes, die das Backend einer abgewiesenen GitHub-Voraussetzung mitgibt (412).
 * Einzige Quelle: wer eine Liste dieser Codes braucht, leitet sie hier ab, statt sie
 * als lose Zeichenketten zu wiederholen — ein Tippfehler faellt sonst erst im Betrieb
 * auf, und zwar als stille Rueckkehr zur allgemeinen Meldung.
 */
export const GITHUB_ERROR_CODES = [
  'GITHUB_TOKEN_MISSING',
  'GITHUB_TOKEN_INVALID',
  'GITHUB_REPO_NOT_FOUND',
  'GITHUB_BRANCH_NOT_FOUND',
  'GITHUB_REPO_NOT_ACCESSIBLE',
  'GITHUB_RATE_LIMITED',
] as const;

export type GithubErrorCode = (typeof GITHUB_ERROR_CODES)[number];

/** `GENERIC` kommt nicht vom Backend, sondern steht fuer eine Absage ohne erkennbaren Grund. */
export type GithubConnectionErrorCode = GithubErrorCode | 'GENERIC';

export function isGithubErrorCode(code: string): code is GithubErrorCode {
  return (GITHUB_ERROR_CODES as readonly string[]).includes(code);
}

export interface GithubConnectionTestResult {
  success: boolean;
  /**
   * Repository-Details vom Backend (GET /repos/{owner}/{repo}) — nur bei success=true gesetzt.
   */
  ownerLogin?: string;
  repoName?: string;
  defaultBranch?: string;
  /**
   * 412-Fehlercode aus dem Backend — nur bei success=false gesetzt.
   */
  errorCode?: GithubConnectionErrorCode;
}
